export default __webpack_public_path__ + "static/embedding-bcaa98c585c8761d93ee7d4338fbfa22.png";